export function replaceHtmlEntity (value: any) {
  let content = value

  content = content.replace(/<p>&nbsp;<\/p>/g, '<br />')
  content = content.replace(/<div>&nbsp;<\/div>/g, '<br />')
  content = content.replace(/&nbsp;/g, ' ')

  return content
}
